var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"750abd1480b5e3c7a1f6ee2272f011ed69beedf1"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/ds_assets/750abd1480b5e3c7a1f6ee2272f011ed69beedf1";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from '@sentry/nextjs';

export function initSentry() {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    denyUrls: [
      /node_modules/,
      /webpack/,
      /cdn.jsdelivr.net/,
      /\/_next\/static\/chunks\//, // Blocks errors from Next.js chunk files
      /chunks\//, // Blocks errors from any chunk file
    ],
    allowUrls: [
      /\/src\//, // Only allow errors from the src folder
    ],
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.01,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
    environment: process.env.NEXT_PUBLIC_CUSTOM_ENV,
    replaysOnErrorSampleRate: 0.01,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.01,

    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: [
      Sentry.replayIntegration({
        // Additional Replay configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    enabled: !(process.env.ENV === 'DEV' || process.env.NEXT_PUBLIC_CUSTOM_ENV === 'DEV'),
  });
}
